<script lang="ts" setup>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';

const { t, availableLocales, locale } = useI18n()
const router = useRouter();
const route = useRoute();

const props = defineProps({
    variant: {
        type: String,
        default: 'default'
    },
    show_iso: {
        type: Boolean,
        default: true
    }
})

const width = computed(()=>{
    return props.variant === 'small' ? '45px' : '200px';
})
const label = computed(()=>{
    if(props.variant === 'small') return '';
    return t('lang_select');
})
const languages_list = computed(()=>{
    //return [];
    return availableLocales.map((lang)=>{
        return {
            label: t(`lang_${lang}`),
            value: lang
        }
    });
})
watch(locale, (newLocale)=>{
    const currentRouteName = route.name;
    if(currentRouteName){
        console.log('cunrrent route name', currentRouteName)
        const newRouteName = `${newLocale}.${currentRouteName.split('.')[1]}`;
        // we replace in the string of params object %2F by /
        //const params = JSON.parse(JSON.stringify(route.params).replace(/%2F/g, '/'));
        const params = route.params;
        /*
        Object.keys(params).forEach(key => {
            if (typeof params[key] === 'string') {
            params[key] = params[key].split('/');
            }
        });
        */
        console.log(params)
        router.push({name: newRouteName, params: params, query: route.query});
    }
})
</script>
<template>
    <div class="locale-changer" v-if="props.variant == 'default'">
        <v-select
            prepend-inner-icon="mdi-earth"
            v-model="$i18n.locale"
            :items="languages_list"
            :label=label
            item-title="label"
            item-value="value"
            density="compact"
            :min-width=width
            hide-details
            variant="solo-filled"
            >
            <template #item="{ item, props }">
                <v-list-item v-bind="props" class="custom-select-item">
                    <template #title>
                        <span>{{ item.raw.label }}</span>
                    </template>
                </v-list-item>
            </template>
        </v-select>
    </div>
    <v-speed-dial v-else
        location="bottom center"
        transition="fade-transition"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <a
                class="text-center"
                v-bind="activatorProps"
            >
                <v-icon size="25" :alt="$t('lang_select')">mdi-earth</v-icon>
                <span v-if="props.show_iso">{{ $i18n.locale.toUpperCase() }}</span>

            </a>
                
            
        </template>
        <v-list lines="one" id="language_change_list">
            <v-list-item
                v-for="lang in languages_list"
                :key="lang.value"
                @click="$i18n.locale = lang.value"
                class="custom-select-item"
                :class="{'v-list-item--active': lang.value == $i18n.locale}"
            >
                <v-list-item-title>{{ lang.label }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-speed-dial>
</template>
<style lang="scss" scoped>
    a{
    position: relative;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    margin: 0 8px;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 58px;
    color: #000;
    font-size: 14px;
    line-height: 17px;
    i{
        height: 21px;
        margin-bottom: 7px;
    }
    span{
        display: inline-block;
        
        border-radius: 12px;
        padding: 0 7px;
    }
}
</style>
<style lang="scss">
.v-list-item.custom-select-item {
    .v-list-item__underlay{
        background-color: white;
        left:0;
        top:0;
        right:0;
        bottom:0;
        z-index: 1;
    }
    .v-list-item__overlay{
        background-color: transparent !important;
        
    }
    .v-list-item__content{
        z-index: 2;
    }
    .v-list-item-title{
        color: black;
        z-index: 2;
    }
  &.v-list-item--active{
    .v-list-item__underlay{
        background-color: #e0e0e0;
    }
    .v-list-item-title{
        color: black !important;
        z-index: 2
    }
  }
  &:hover{
    .v-list-item__underlay{
        background-color: #e0e0e0;
    }
    .v-list-item-title{
        color: black;
    }
  }
}
</style>